class ProductGallery extends HTMLElement {
    constructor() {
        super();
        this.container = this.querySelector('.swiper');
    }

    connectedCallback() {
        function isPhone() {
            return window.innerWidth < 769
        }
        var thumbsSwiper = new Swiper(document.querySelector('.swiper--product-thumbs'), {
            direction: "horizontal",
            centeredSlides: true,
            centeredSlidesBounds: true,
            freeMode: true,
            mousewheel: true,
            slidesPerView: "auto",
            spaceBetween: 8,
            breakpoints: {
                750: {
                    spaceBetween: 16,
                    direction: "horizontal"
                },
                990: {
                    spaceBetween: 16,
                    direction: "vertical"
                }
            }
        })
        this.swiper = new Swiper(this.container, {
            autoHeight: false,
            slidesPerView: 1.125,
            spaceBetween: 8,
            thumbs: {
                swiper: thumbsSwiper,
            },
        })
        document.querySelectorAll('.swiper--product-thumbs .swiper-slide').forEach(slide => {
            slide.addEventListener('click', () => {
                this.swiper.slideTo(slide.dataset.index)
            })
        })
        const lightbox = new PhotoSwipeLightbox({
            gallery: '.photoswipe-wrapper',
            children: '.product__gallery-toggle',
            allowPanToNext: true,
            spacing: 0,
            arrowPrevSVG: '<span class="icon--rotate-180"><svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 4L17 12L9 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>',
            arrowNextSVG: '<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 4L17 12L9 20" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>',
            closeSVG: '<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 5L19 19M19 5L5 19" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"></path></svg>',
            pswpModule: () => PhotoSwipe,
            mainClass: "pswp--product-media-gallery",
            loop: !1,
            showHideAnimationType: "zoom",
            initialZoomLevel: zoomLevelObject => isPhone() ? zoomLevelObject.vFill : zoomLevelObject.fit,
            secondaryZoomLevel: zoomLevelObject => isPhone() ? zoomLevelObject.fit : 1,
        });
        lightbox.init();
    }
}
customElements.define('swiper-product-gallery', ProductGallery);
class ProductThumbnails extends HTMLElement {
    constructor() {
        super();
        this.container = this.querySelector('.swiper--product-thumbs');
    }

    connectedCallback() {
        function isPhone() {
            return window.innerWidth < 769
        }
        
        // this.swiper = new Swiper(this.container, {
        //     direction: "horizontal",
        //     centeredSlides: true,
        //     centeredSlidesBounds: true,
        //     freeMode: true,
        //     mousewheel: true,
        //     slidesPerView: "auto",
        //     spaceBetween: 8,
        //     breakpoints: {
        //         750: {
        //             spaceBetween: 16,
        //             direction: "horizontal"
        //         },
        //         990: {
        //             spaceBetween: 16,
        //             direction: "vertical"
        //         }
        //     }
        // })
    }
}
customElements.define('swiper-product-thumbs', ProductThumbnails);